/* Hörnwidgetens stilar (KanaiWidget.jsx). Ren flytt ur KanaiWidget.jsx
   2026-10-26 så att komponentfilen håller sig under 1 000 rader. */
const css = `
.kanai-widget-fab {
  /* z 150: över adminbaren (--z-admin 100) men UNDER dropdowns (200),
     modaler (--z-modal 500) och toasts (900). Låg tidigare på 1000 och
     täckte panelknappar i alla moduler som följer DS-z-skalan
     (upptäckt i HMS 2026-07-25). */
  position: fixed; bottom: var(--kanai-widget-fab-bottom, 24px); right: 24px; z-index: 150;
  width: 52px; height: 52px; border-radius: 50%;
  background: linear-gradient(135deg, var(--kp-purple-fill, #7C3AED) 0%, var(--kp-purple-fill-hover, #6D28D9) 100%);
  border: none; cursor: pointer; display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 16px rgba(124,58,237,.35), 0 2px 6px rgba(0,0,0,.1);
  transition: transform .15s ease, box-shadow .15s ease, bottom .5s cubic-bezier(.4,0,.2,1), opacity .4s ease;
  color: var(--kp-on-fill, #fff);
}
.kanai-widget-fab:hover {
  transform: scale(1.07);
  box-shadow: 0 6px 24px rgba(124,58,237,.45), 0 3px 10px rgba(0,0,0,.15);
}
.kanai-widget-fab:active { transform: scale(0.97); }

/* Mobil (responsiv baslinje Track 0): mindre FAB, tätare mot hörnet
   så den täcker mindre av primärt innehåll/CTA:er på liten skärm */
@media (max-width: 639px) {
  .kanai-widget-fab {
    width: 44px; height: 44px;
    right: 12px;
    bottom: var(--kanai-widget-fab-bottom, 12px);
  }
  .kanai-widget-fab svg { width: 20px; height: 20px; }
  /* 16 px så att iPhone Safari inte zoomar in vid fokus; skicka 44 px (U30/U31). */
  .kanai-widget-input { font-size: 16px; }
  .kanai-widget-send { width: 44px; height: 44px; }

  /* Inkorg: när en konversation är öppen ligger skrivfältet exakt där
     FAB:en sitter — dölj den så skicka-ytan inte blockeras (mobil-fynd
     2026-07-25, stage-mobil-06). Listvyn behåller FAB:en. */
  body:has(.kp-inbox-root.kp-chat-active) .kanai-widget-fab {
    display: none;
  }
}

/* Snoozed state — hides behind footer, 20% peeking */
.kanai-widget-fab--snoozed {
  bottom: -40px;
  opacity: 0.35;
  transform: scale(0.85);
  box-shadow: none;
}
.kanai-widget-fab--snoozed:hover {
  bottom: -30px;
  opacity: 0.7;
  transform: scale(0.92);
  box-shadow: 0 2px 10px rgba(124,58,237,.25);
}

/* Ram runt panelen (WebKit-fynd 2026-10-21, iPhone 393 px): en stängd panel
   som ligger utanför kanten breddade sidan. Ramen klipper den. */
.kanai-widget-ram {
  position: fixed; inset: 0; overflow: hidden; pointer-events: none;
  z-index: var(--z-modal, 500);
}
.kanai-widget-panel {
  /* Öppen panel beter sig som modal — DS-skalans --z-modal (via ramen). */
  position: absolute; top: 0; right: 0; bottom: 0; pointer-events: auto;
  width: 380px; max-width: 100vw;
  background: var(--kp-white, #ffffff);
  border-left: 1px solid var(--kp-border, #e2e8f0);
  box-shadow: -4px 0 24px rgba(0,0,0,.08);
  display: flex; flex-direction: column;
  font-family: 'Inter', sans-serif;
  transform: translateX(100%);
  /* Stängd panel göms helt efter utglidningen (ingen tabbfokus, ingen bredd). */
  visibility: hidden;
  transition: transform .25s cubic-bezier(.4,0,.2,1), visibility 0s linear .25s;
}
.kanai-widget-panel.open {
  transform: translateX(0); visibility: visible;
  transition: transform .25s cubic-bezier(.4,0,.2,1), visibility 0s;
}

.kanai-widget-backdrop {
  /* Strax under panelen — samma mönster som DS-slideovers (499/500). */
  position: fixed; inset: 0; z-index: 499;
  background: rgba(0,0,0,.15);
  opacity: 0; transition: opacity .2s ease;
  pointer-events: none;
}
.kanai-widget-backdrop.open { opacity: 1; pointer-events: auto; }

.kanai-widget-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid var(--kp-border, #e2e8f0);
  flex-shrink: 0;
}
.kanai-widget-header h3 {
  margin: 0; font-size: 15px; font-weight: 600; color: var(--kp-text, #1e293b);
  display: flex; align-items: center; gap: 8px;
}
.kanai-widget-header .ai-badge {
  font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 6px;
  background: var(--kp-purple-fill, #7C3AED); color: var(--kp-on-fill, #fff); letter-spacing: 0.04em;
}

.kanai-widget-body {
  flex: 1; overflow-y: auto; padding: 20px;
  display: flex; flex-direction: column; gap: 16px;
}

.kanai-widget-empty {
  flex: 1; display: flex; flex-direction: column; align-items: center;
  justify-content: center; gap: 12px; color: var(--kp-text-muted, #64748b);
  text-align: center; padding: 32px 16px;
}
.kanai-widget-empty svg { opacity: .4; }
.kanai-widget-empty p { font-size: 13px; margin: 0; max-width: 240px; line-height: 1.5; }

/* ── Capability panel (empty-state) ── */
.kanai-caps {
  border: 1px solid var(--kp-border, #e2e8f0); border-radius: 12px;
  background: var(--kp-white, #fff); overflow: hidden;
}
.kanai-caps-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px; cursor: pointer; user-select: none;
  background: var(--kp-purple-tint, #FAF5FF);
  border-bottom: 1px solid transparent;
  transition: background .15s ease;
}
.kanai-caps-header:hover { background: var(--kp-purple-light, #F3E8FF); }
.kanai-caps.open .kanai-caps-header { border-bottom-color: var(--kp-border, #e2e8f0); }
.kanai-caps-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 600; color: var(--kp-text, #1e293b);
}
.kanai-caps-title svg { color: var(--kp-ai-ink, #7C3AED); }
.kanai-caps-chevron {
  color: var(--kp-text-muted, #64748b);
  transition: transform .2s ease;
}
.kanai-caps.open .kanai-caps-chevron { transform: rotate(180deg); }
.kanai-caps-list {
  display: flex; flex-direction: column;
}
.kanai-cap-item {
  border-bottom: 1px solid var(--kp-border, #e2e8f0);
}
.kanai-cap-item:last-child { border-bottom: none; }
.kanai-cap-row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; cursor: pointer; user-select: none;
  background: var(--kp-white, #fff); transition: background .15s ease;
  border: none; width: 100%; text-align: left;
  font-family: 'Inter', sans-serif;
}
.kanai-cap-row:hover { background: var(--kp-inset, #f8fafc); }
.kanai-cap-row-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 12.5px; font-weight: 600; color: var(--kp-text, #1e293b);
}
.kanai-cap-row-badge {
  font-size: 11px; font-weight: 700; letter-spacing: 0.05em;
  background: var(--kp-purple-fill, #7C3AED); color: var(--kp-on-fill, #fff);
  padding: 1px 6px; border-radius: 4px;
}
.kanai-cap-row-chevron {
  color: var(--kp-text-muted, #64748b);
  transition: transform .2s ease;
}
.kanai-cap-item.open .kanai-cap-row-chevron { transform: rotate(180deg); }
.kanai-cap-body {
  padding: 4px 14px 12px 14px; background: var(--kp-inset, #f8fafc);
  border-top: 1px solid var(--kp-border, #e2e8f0);
}
.kanai-cap-body ul {
  margin: 8px 0 0; padding-left: 18px;
  font-size: 12px; line-height: 1.55; color: var(--kp-text, #1e293b);
}
.kanai-cap-body li { margin-bottom: 4px; }

.kanai-caps-admin {
  border-top: 1px solid var(--kp-border, #e2e8f0);
  padding: 10px 14px; background: var(--kp-inset, #f8fafc);
}
.kanai-caps-admin-btn {
  background: none; border: none; padding: 0; cursor: pointer;
  font-size: 11.5px; font-weight: 600; color: var(--kp-ai-ink, #7C3AED);
  letter-spacing: 0.03em; font-family: 'Inter', sans-serif;
}
.kanai-caps-admin-btn:hover { text-decoration: underline; }
.kanai-caps-admin-raw {
  margin-top: 10px; max-height: 260px; overflow: auto;
  background: var(--kp-white, #fff); border: 1px solid var(--kp-border, #e2e8f0);
  border-radius: 8px; padding: 10px 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px; line-height: 1.55; color: var(--kp-text, #1e293b);
}
.kanai-caps-admin-raw .tool {
  padding: 6px 0; border-bottom: 1px dashed var(--kp-border, #e2e8f0);
}
.kanai-caps-admin-raw .tool:last-child { border-bottom: none; }
.kanai-caps-admin-raw .tool-name { font-weight: 700; color: var(--kp-ai-ink, #7C3AED); }
.kanai-caps-admin-raw .tool-tier {
  font-size: 11px; font-weight: 700; letter-spacing: 0.04em;
  padding: 1px 5px; border-radius: 4px; margin-left: 6px;
  background: var(--kp-inset, #f1f5f9); color: var(--kp-text-muted, #64748b);
}
.kanai-caps-admin-raw .tool-desc {
  margin-top: 3px; font-family: 'Inter', sans-serif; font-size: 11.5px;
  color: var(--kp-text-muted, #64748b);
}

.kanai-widget-answer {
  font-size: 13.5px; line-height: 1.6; color: var(--kp-text, #1e293b);
}
.kanai-widget-answer p { margin: 0 0 8px; }
.kanai-widget-answer p:last-child { margin-bottom: 0; }
.kanai-widget-answer strong { font-weight: 600; color: var(--kp-text, #1e293b); }
.kanai-widget-answer em { font-style: italic; }
.kanai-widget-answer ul, .kanai-widget-answer ol { margin: 4px 0 8px; padding-left: 18px; }
.kanai-widget-answer li { margin-bottom: 3px; }
.kanai-widget-answer h1,
.kanai-widget-answer h2,
.kanai-widget-answer h3,
.kanai-widget-answer h4 {
  margin: 14px 0 6px; font-weight: 700; color: var(--kp-text, #1e293b);
  line-height: 1.35;
}
.kanai-widget-answer h1 { font-size: 15px; }
.kanai-widget-answer h2 { font-size: 14px; }
.kanai-widget-answer h3 { font-size: 13.5px; }
.kanai-widget-answer h4 { font-size: 13px; }
.kanai-widget-answer > *:first-child { margin-top: 0; }
.kanai-widget-answer hr {
  border: none; border-top: 1px solid var(--kp-border, #e2e8f0);
  margin: 14px 0;
}
.kanai-widget-answer code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px; background: var(--kp-inset, #f1f5f9);
  padding: 1px 5px; border-radius: 4px;
}
.kanai-widget-answer pre {
  background: var(--kp-inset, #f1f5f9); padding: 10px 12px;
  border-radius: 8px; overflow-x: auto; font-size: 12px; margin: 8px 0;
}
.kanai-widget-answer pre code { background: transparent; padding: 0; }
.kanai-widget-answer blockquote {
  border-left: 3px solid var(--kp-purple, #7C3AED); padding: 4px 12px;
  margin: 8px 0; background: var(--kp-purple-tint, #FAF5FF); border-radius: 0 6px 6px 0;
  color: var(--kp-text, #1e293b);
}
.kanai-widget-answer a { color: var(--kp-ai-ink, #7C3AED); text-decoration: none; }
.kanai-widget-answer a:hover { text-decoration: underline; }
.kanai-widget-answer .kanai-table-wrap {
  width: 100%; overflow-x: auto; margin: 8px 0;
  border: 1px solid var(--kp-border, #e2e8f0); border-radius: 8px;
}
.kanai-widget-answer table {
  width: 100%; border-collapse: collapse; font-size: 12.5px;
}
.kanai-widget-answer thead { background: var(--kp-inset, #f8fafc); }
.kanai-widget-answer th {
  text-align: left; padding: 8px 10px; font-weight: 600;
  border-bottom: 1px solid var(--kp-border, #e2e8f0);
  color: var(--kp-text, #1e293b); white-space: nowrap;
}
.kanai-widget-answer td {
  padding: 7px 10px; border-bottom: 1px solid var(--kp-border, #e2e8f0);
  vertical-align: top;
}
.kanai-widget-answer tbody tr:last-child td { border-bottom: none; }
.kanai-widget-answer .kanai-citation {
  font-size: 11px; font-weight: 600; color: var(--kp-ai-ink, #7C3AED);
  background: var(--kp-purple-light, #F3E8FF); padding: 1px 5px; border-radius: 4px;
  cursor: default;
}

.kanai-widget-question {
  background: var(--kp-inset, #f1f5f9); border-radius: 10px; padding: 12px 14px;
  font-size: 13px; color: var(--kp-text, #1e293b); line-height: 1.5;
}

.kanai-widget-sources {
  font-size: 12px; color: var(--kp-text-muted, #64748b);
  border-top: 1px solid var(--kp-border, #e2e8f0);
  padding-top: 12px; margin-top: 4px;
}
.kanai-widget-sources strong { font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; }
.kanai-widget-sources ul { margin: 6px 0 0 14px; padding: 0; }
.kanai-widget-sources li { margin-bottom: 3px; }

.kanai-widget-footer {
  padding: 14px 20px; border-top: 1px solid var(--kp-border, #e2e8f0);
  flex-shrink: 0; display: flex; flex-direction: column; gap: 10px;
}
.kanai-widget-input-row {
  display: flex; gap: 8px; align-items: flex-end;
}
.kanai-widget-input {
  flex: 1; resize: none; border: 1px solid transparent;
  background: var(--kp-inset, #f1f5f9); border-radius: 10px;
  padding: 10px 14px; font-size: 13px; font-family: 'Inter', sans-serif;
  color: var(--kp-text, #1e293b); outline: none;
  min-height: 40px; max-height: 120px;
  transition: border-color .15s ease, background .15s ease, box-shadow .15s ease;
}
.kanai-widget-input:focus {
  background: var(--kp-white, #fff);
  border-color: var(--kp-accent, #3B82F6);
  box-shadow: 0 0 0 3px var(--kp-accent-ring, rgba(59,130,246,.15));
}
.kanai-widget-input::placeholder { color: var(--kp-text-muted, #94a3b8); }
.kanai-widget-send {
  width: 40px; height: 40px; border-radius: 10px; border: none;
  background: var(--kp-purple-fill, #7C3AED); color: var(--kp-on-fill, #fff); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; transition: background .15s ease;
}
.kanai-widget-send:hover { background: var(--kp-purple-fill-hover, #6D28D9); }
.kanai-widget-send:disabled { opacity: .4; cursor: default; }

.kanai-widget-footer-link {
  font-size: 12px; color: var(--kp-ai-ink, #7C3AED); text-decoration: none; font-weight: 500;
  text-align: center; display: block;
}
.kanai-widget-footer-link:hover { text-decoration: underline; }
.kanai-widget-sparfel {
  font-size: 12px; color: var(--kp-text-muted, #64748B); text-align: center; margin-bottom: 4px;
}

.kanai-widget-loading {
  display: flex; align-items: center; gap: 8px; font-size: 13px;
  color: var(--kp-text-muted, #64748b); padding: 8px 0;
}
.kanai-widget-loading .dot-pulse {
  display: inline-flex; gap: 4px;
}
.kanai-widget-loading .dot-pulse span {
  width: 6px; height: 6px; border-radius: 50%; background: var(--kp-purple, #7C3AED);
  animation: kwPulse .8s infinite ease-in-out;
}
.kanai-widget-loading .dot-pulse span:nth-child(2) { animation-delay: .15s; }
.kanai-widget-loading .dot-pulse span:nth-child(3) { animation-delay: .3s; }
@keyframes kwPulse {
  0%, 80%, 100% { opacity: .25; transform: scale(.8); }
  40% { opacity: 1; transform: scale(1); }
}

.kanai-widget-close {
  background: none; border: none; cursor: pointer; padding: 4px;
  color: var(--kp-text-muted, #64748b); border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  transition: background .15s ease;
}
.kanai-widget-close:hover { background: var(--kp-inset, #f1f5f9); }

.kanai-widget-ai-ikon { color: var(--kp-ai-ink, #7C3AED); flex-shrink: 0; }
.kanai-widget-kalla {
  border: none; background: none; padding: 0; font: inherit; text-align: left;
  color: var(--kp-accent, #3B82F6); text-decoration: underline; cursor: pointer;
}
.kanai-widget-kalla:focus-visible { outline: none; box-shadow: 0 0 0 3px var(--kp-accent-ring, rgba(59,130,246,0.25)); border-radius: 4px; }
.kanai-widget-answer.fel { color: var(--kp-red-ink, #B91C1C); }
.kanai-widget-answer .kanai-citation--knapp {
  border: none; font-family: inherit; line-height: inherit; cursor: pointer;
}
.kanai-widget-answer .kanai-citation--knapp:hover { text-decoration: underline; }
.kanai-widget-answer .kanai-citation--knapp:focus-visible {
  outline: none; box-shadow: 0 0 0 3px var(--kp-accent-ring, rgba(59,130,246,0.25));
}
`;

export default css;
